import type { TrackingEventName } from '~/shared/tracking/job-architecture-tracking-events';

export const trackableEvents: readonly TrackingEventName[] = [
    'ai-action-used',
    'architecture-search-executed',
    'changelog-opened',
    'job-architecture-deleted',
    'job-role-exported',
    'job-role-version-saved',
    'job-role-workflow-transition',
    'page-view',
    'role-skill-change',
    'settings-changed',
];
